import { useState } from 'react';
import { Menu, X } from 'lucide-react';

export default function Navigation() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const links = [
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Features', href: '#features' },
    { label: 'Who It\'s For', href: '#audience' },
    { label: 'Pricing', href: '#pricing' },
  ];

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav data-testid="nav-container" className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-vf-salt/80 border-b border-vf-sage/60">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16">
        {/* Logo */}
        <a href="#" data-testid="nav-logo" className="flex items-center gap-2 font-heading text-2xl font-bold text-vf-forest tracking-tight">
          VitalsFlow
          <span className="inline-block w-2 h-2 rounded-full bg-vf-mint pulse-dot" />
          <span className="text-vf-charcoal font-body text-sm font-medium ml-[-4px]">AI</span>
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {links.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className="font-body text-sm text-vf-charcoal/70 hover:text-vf-forest transition-colors duration-200 tracking-wide"
            >
              {link.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-button"
            onClick={() => scrollTo('#demo-form')}
            className="font-body text-sm font-semibold bg-vf-forest text-vf-salt px-5 py-2.5 hover:bg-vf-forest/90 transition-colors duration-200"
          >
            Request a Demo
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-vf-charcoal"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-vf-salt/95 backdrop-blur-xl border-t border-vf-sage/40 px-4 pb-6 pt-2">
          {links.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className="block w-full text-left font-body text-base text-vf-charcoal/80 py-3 border-b border-vf-sage/30 hover:text-vf-forest transition-colors"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('#demo-form')}
            className="mt-4 w-full font-body text-sm font-semibold bg-vf-forest text-vf-salt px-5 py-3 hover:bg-vf-forest/90 transition-colors"
          >
            Request a Demo
          </button>
        </div>
      )}
    </nav>
  );
}
